import { render, staticRenderFns } from "./PayCommandeForm.vue?vue&type=template&id=81b2d586&"
import script from "./PayCommandeForm.vue?vue&type=script&lang=js&"
export * from "./PayCommandeForm.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports